var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96997 15.3355L12.2243 17.5899C12.5638 17.9294 13.1122 17.9294 13.4516 17.5899L15.706 15.3355C16.2544 14.7872 15.8627 13.8471 15.088 13.8471H10.5793C9.80459 13.8471 9.42161 14.7872 9.96997 15.3355Z",
    fill: "#91919A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96997 9.23175L12.2243 6.97737C12.5638 6.63791 13.1122 6.63791 13.4516 6.97737L15.706 9.23175C16.2544 9.78011 15.8627 10.7202 15.088 10.7202H10.5793C9.80459 10.7202 9.42161 9.78011 9.96997 9.23175Z",
    fill: "#006DD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.9e276bbd78f294ee49bdedd39039ec8a.svg";
export { ForwardRef as ReactComponent };